import { PasswordErrors } from '../models';

const PASSWORD_VALIDATION = {
  numbers: /[0-9]/,
  lowerCases: /[a-z]/,
  upperCases: /[A-Z]/,
  specialCharacters: /[ !"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/,
  minimumPasswordLength: 8,
};

const validatePassword = (password?: string, repeatPassword?: string): PasswordErrors | undefined => {
  let errorsObject: PasswordErrors | undefined;

  if (password) {
    errorsObject = {
      arePasswordsEqual: String(password) === String(repeatPassword),
      hasLowerCaseLetter: PASSWORD_VALIDATION.lowerCases.test(password),
      hasUppercaseCharacter: PASSWORD_VALIDATION.upperCases.test(password),
      hasMinimumLength: password.length >= PASSWORD_VALIDATION.minimumPasswordLength,
      hasSpecialCharacter: PASSWORD_VALIDATION.specialCharacters.test(password),
      hasNumber: PASSWORD_VALIDATION.numbers.test(password),
    };
  }

  return errorsObject;
};

export default validatePassword;
